import React from 'react';
import './myReserves.css';
import { useDispatch, useSelector } from "react-redux";
import { setMyReservesAction } from "../../redux/actions";
import { MY_RESERVES_INITIAL } from "../../redux/initialStateConstants";
import { removeReserveSagaAction } from "../../redux/sagaActions";

const MyReserves = () => {
    const dispatch = useDispatch();
    const my_reserves = useSelector(state => state.my_reserves);

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <div className="form__close"
                            onClick={ () => {
                                dispatch(setMyReservesAction(MY_RESERVES_INITIAL));
                            } }
                        />
                        <div className="form__title">Мои записи</div>
                    </div>
                    <div className="form__field">
                        {
                            my_reserves.reserves.length > 0
                            ?
                            my_reserves.reserves.map(elem => (
                                <div key={ elem.id } className="service">
                                    <div className="service__header">
                                        <div className="service__name">
                                            {
                                                elem.service.map((el, index) => (
                                                    <div key={ index }>{ `${ index + 1 }. ${ el }` }</div>
                                                ))
                                            }
                                        </div>
                                        <div className="service__remove"
                                            onClick={ () => {
                                                if (!window.confirm('Вы действительно хотите удалить запись?')) return;
                                                dispatch(removeReserveSagaAction({ reserve_id: elem.id }));
                                            } }
                                        />
                                    </div>
                                    <div className="service__master">{ elem.master }</div>
                                    <div className="service__date">{ elem.date }</div>
                                    <div className="service__time">{ elem.time }</div>
                                </div>
                            ))
                            :
                            <div className="empty_list">Записей нет</div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MyReserves;